import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import About from './components/About';
/*import Navbar from './components/Navbar';*/
import Projects from './components/Projects';
import Home from './pages/Home';
import ProjectDetails from "./pages/ProjectDetails";


function App() {
  return (
    <Router>
      <main className="body-font">
        
      {/* <Navbar /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:projectId" element={<ProjectDetails />} />
        </Routes>
    </main>
  </Router>
  );
}

export default App;
